// startup
// Load entry module and return exports
__webpack_require__("./node_modules/babel-polyfill/lib/index.js");
__webpack_require__("./Assets/Scripts/main.js");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./Assets/Styles/main.css");
